const initialState = {};

function reducer(state = initialState, action) {
    if (['AUTHENTICATE_REQUEST', 'LOGOUT_REQUEST', 'RESET_APM_PROVISION'].includes(action.type)) {
        return initialState;
    }

    if (action.type === 'UPDATE_APM_PROVISION_FIELDS_SUCCESS') {
        const { apmId, showConfirmationDialog } = action.actionParams;
        if (showConfirmationDialog) {
            return {
                ...state,
                [apmId]: {
                    ...state[apmId],
                    dialog: 'confirmation',
                },
            };
        }
    }

    if (action.type === 'SET_APM_PROVISION_DIALOG') {
        const { apmId, dialog } = action.payload;
        return {
            ...state,
            [apmId]: {
                ...state[apmId],
                dialog,
            },
        };
    }

    if (action.type === 'SET_IS_APM_PROVISION') {
        const { apmId, isApmProvisionVisible } = action.payload;
        return {
            ...state,
            [apmId]: {
                ...state[apmId],
                isApmProvisionVisible,
            },
        };
    }

    return state;
}

export default reducer;
